export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  blockTxs: (state) => state.blockTxs,
  blockTxsOffest: (state) => state.blockTxsOffest,
  blockTxsPagination: (state) => state.blockTxsPagination,
  blockTxsTotal: (state) => {
    const total = state.blockTxsPagination?.total;
    return total ? parseInt(total, 10) : 0;
  },
  blockValidatorSets: (state) => state.blockValidatorSets,
  blocks: (state) => state.blocks,
  currentHeight: (state) => state.currentHeight,
  detail: (state) => state.detail,
  isAddingBlocks: (state) => state.isAddingBlocks,
  isSearching: (state) => state.isSearching,
  newHeight: (state) => state.newHeight,
  supposedTime: (state) => state.supposedTime?.milliseconds || 0,
};
